var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"margin-right":"10px"}},[_c('el-tooltip',{attrs:{"content":"点击打开【我的菜单】-查看完整的菜单","placement":"left-end","effect":"light"}},[_c('el-button',{attrs:{"circle":"","icon":"el-icon-menu","size":"medium","title":"我的菜单"},on:{"click":_vm.goToPage}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }